"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDate = void 0;
const constant_1 = require("./constant");
const getFormatParts = (format) => {
    const formatParts = format.match(constant_1.FORMATTING_TOKENS) || [];
    return formatParts.map((token) => {
        const parseTo = constant_1.EXPRESSIONS[token];
        const regex = parseTo && parseTo[0];
        const key = parseTo && parseTo[1];
        const execute = parseTo && parseTo[2];
        return key ? { regex, key, execute } : token;
    });
};
const getDataObject = (date, formatParts) => {
    const dateObject = {};
    let dateString = date;
    formatParts.forEach(token => {
        if (typeof token === 'string') {
            dateString = dateString.replace(token, '');
        }
        else {
            const { regex, key, execute } = token;
            const match = regex.exec(dateString);
            const value = match ? match[0] : '';
            dateObject[key] = execute ? execute(value) : +value;
            dateString = dateString.replace(value, '');
        }
    });
    return dateObject;
};
const isValidDate = (date) => {
    return date instanceof Date && !isNaN(Number(date));
};
// eslint-disable-next-line complexity
const transformDate = (date, format) => {
    if (typeof date === 'number') {
        return new Date(date);
    }
    if (!format) {
        const dateInstance = new Date(date);
        if (!isValidDate(dateInstance)) {
            throw Error('Date is invalid');
        }
        return dateInstance;
    }
    const formatParts = getFormatParts(format);
    const dateObject = getDataObject(date, formatParts);
    const { year, month, day, hours, minutes, seconds } = dateObject;
    const today = new Date();
    const auxYear = year || today.getFullYear();
    const auxMonth = month ? month - 1 : today.getMonth();
    const auxDay = day || today.getDate();
    const auxHours = hours || 0;
    const auxMinutes = minutes || 0;
    const auxSeconds = seconds || 0;
    return new Date(auxYear, auxMonth, auxDay, auxHours, auxMinutes, auxSeconds);
};
exports.transformDate = transformDate;
//# sourceMappingURL=transformDate.js.map